const DEFAULT_LINK_SELECTOR = 'a'
const DEFAULT_INITIALIZED_DATA_KEY = 'smoothAnchorLinksInitialized'
const EXPLICIT_LINK_SELECTOR = 'a[data-smooth-anchor]'
const EXPLICIT_INITIALIZED_DATA_KEY = 'explicitSmoothAnchorLinksInitialized'

export function initSmoothAnchorLinks() {
  initSmoothAnchorLinkListener(DEFAULT_LINK_SELECTOR, DEFAULT_INITIALIZED_DATA_KEY)
}

export function initExplicitSmoothAnchorLinks() {
  initSmoothAnchorLinkListener(EXPLICIT_LINK_SELECTOR, EXPLICIT_INITIALIZED_DATA_KEY)
}

function initSmoothAnchorLinkListener(selector, initializedDataKey) {
  if (document.documentElement.dataset[initializedDataKey] === 'true') return

  document.addEventListener('click', (event) => handleSmoothAnchorClick(event, selector))
  document.documentElement.dataset[initializedDataKey] = 'true'
}

export function handleSmoothAnchorClick(event, selector = DEFAULT_LINK_SELECTOR) {
  if (event.defaultPrevented) return
  if (!(event.target instanceof Element)) return

  const link = event.target.closest(selector)
  if (!(link instanceof HTMLAnchorElement)) return
  if (link.classList.contains('toggle-toc')) return

  const targetHash = toSamePageHash(link)
  if (targetHash === null) return

  const target = targetHash === '#' ? document.documentElement : document.getElementById(targetHash.slice(1))
  if (!(target instanceof Element)) return

  event.preventDefault()
  const headerHeight = 105
  const position = target.getBoundingClientRect().top + window.scrollY - headerHeight
  window.scrollTo({ top: position, behavior: 'smooth' })
}

function toSamePageHash(link) {
  const href = link.getAttribute('href')
  if (href === null || href === '') return null
  if (href.startsWith('#')) return href

  const url = new URL(link.href)
  if (url.hash === '') return null
  if (url.origin !== window.location.origin) return null
  if (url.pathname !== window.location.pathname) return null

  return url.hash
}
